module.exports = __webpack_public_path__ + "img/splash.566b6ecf.png";